<div *ngIf="summaryRaw && portfolioPerformance">
    <div class="mb-3">
        <app-summary-cards [summaryRaw]="summaryRaw" [portfolioPerformance]="portfolioPerformance" [benchmark]="benchmark" [etfOnly]="etfOnly"></app-summary-cards>
    </div>
</div>
